var React = require('react');

function Facebook (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".facebook-icon-svg-1{fill:#3c5a99;}.facebook-icon-svg-2{fill:#fff;}")),React.createElement("path",{"id":"Blue","className":"facebook-icon-svg-1","d":"M18.9,20A1.1,1.1,0,0,0,20,18.9V1.15A1.1,1.1,0,0,0,18.9.05H1.15a1.1,1.1,0,0,0-1.1,1.1V18.9A1.1,1.1,0,0,0,1.15,20Z","key":1}),React.createElement("path",{"id":"f","className":"facebook-icon-svg-2","d":"M13.82,20V12.27h2.59l.39-3h-3V7.34c0-.87.24-1.46,1.49-1.46H16.9V3.18a20.19,20.19,0,0,0-2.32-.12,3.63,3.63,0,0,0-3.87,4V9.26H8.11v3h2.6V20Z","key":2})]);
}

Facebook.defaultProps = {"id":"Layer_2","data-name":"Layer 2","viewBox":"0 0 20 20","width":"20","height":"20"};

module.exports = Facebook;

Facebook.default = Facebook;
